import { render, staticRenderFns } from "./PartOrderModal.vue?vue&type=template&id=46063622&scoped=true"
import script from "./PartOrderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PartOrderModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46063622",
  null
  
)

export default component.exports